/**
 * Redirects to AAD login with post-login redirect URI.
 * Uses SWA's native post_login_redirect_uri parameter so the user
 * returns to their original page after authentication.
 */
export function redirectToLogin(returnPath?: string): void {
    const path = returnPath || window.location.pathname + window.location.search;
    const redirectUri = encodeURIComponent(path);
    window.location.href = `/.auth/login/aad?post_login_redirect_uri=${redirectUri}`;
}
